import { Selector } from 'react-redux';
import { RootState } from '../../redux/root-reducer';
import { IWorkProfile } from '../../types/global/helper';
import { createSelector } from 'reselect';
import { ITalentFilters } from '../../redux/talent/types';

export const talentsSelector: Selector<RootState, IWorkProfile[]> = createSelector(
    (state: RootState) => state.userTalent,
    talent => talent.allTalents ?? [],
);

export const filtersSelector: Selector<RootState, ITalentFilters | undefined> = createSelector(
    (state: RootState) => state.userTalent,
    talents => talents.filters,
);

export const loadingSelector: Selector<RootState, boolean> = createSelector(
    (state: RootState) => state.userTalent,
    talents => talents.gettingTalents,
);
